import { render, staticRenderFns } from "./CommentCard.vue?vue&type=template&id=83d9fd8e"
import script from "./CommentCard.vue?vue&type=script&lang=js"
export * from "./CommentCard.vue?vue&type=script&lang=js"
import style0 from "./CommentCard.vue?vue&type=style&index=0&id=83d9fd8e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports